import React from 'react';
import { useAppTheme } from '../../context/ThemeContext';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  helperText?: string;
  label?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className = '', error, helperText, label, ...props }, ref) => {
    const { themeConfig } = useAppTheme();

    const getTextAreaStyles = () => {
      const baseStyles = 'block w-full rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
      const errorStyles = error
        ? `border-[${themeConfig.error}] focus:ring-[${themeConfig.error}]`
        : `border-[${themeConfig.accent}] focus:ring-[${themeConfig.primary}]`;
      
      return `${baseStyles} ${errorStyles} px-3 py-2 bg-[${themeConfig.surface}] text-[${themeConfig.text}] border ${className}`;
    };

    return (
      <div className="space-y-1">
        {label && (
          <label className={`block text-sm font-medium text-[${themeConfig.text}]`}>
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          className={getTextAreaStyles()}
          {...props}
        />
        {error && (
          <p className={`text-sm text-[${themeConfig.error}]`}>
            {error}
          </p>
        )}
        {helperText && !error && (
          <p className={`text-sm text-[${themeConfig.text}] opacity-70`}>
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea; 